// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.FiCheckCircle = function FiCheckCircle(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M22 11.08V12a10 10 0 1 1-5.93-9.14"
      }
    }, {
      "tag": "polyline",
      "attr": {
        "points": "22 4 12 14.01 9 11.01"
      }
    }]
  })(props);
};